import { useNavigate } from 'react-router-dom';

import { COMPLIANCE_TERMS_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useComplianceTermsListActions = (id: string | number) => {
    const navigate = useNavigate();

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${COMPLIANCE_TERMS_EDIT}/${id}`);
    };

    return {
        handleEdit,
    };
};
